import { Injectable } from '@angular/core';
import { ViaCepAddress } from '../models/viaCEP/viaCepAddress';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ViaCepService {
  constructor(protected http: HttpClient) {}

  find(cep: string): Observable<ViaCepAddress> {
    const url = `${environment.viaCepSettings.url}/${cep}/${environment.viaCepSettings.typeResult}`;
    return this.http.get<ViaCepAddress>(url);
  }
}
